import request from '@/utils/httpRequest'

export function addRoom (data) {
  return request({
    url: `/room_info`,
    method: 'post',
    data
  })
}
export function getPointList () {
  return request({
    url: `/room_info/pointList`,
    method: 'get'
  })
}
export function getRoomList (params) {
  return request({
    url: `/room_info/listPage`,
    method: 'get',
    params
  })
}
export function batchDelete (data) {
  return request({
    url: `/room_info/batchDelete`,
    method: 'post',
    data
  })
}
export function getEquipmentList (params) {
  return request({
    url: `/equipment_info/listPage`,
    method: 'get',
    params
  })
}
export function getDeviceType (params) {
  return request({
    url: `/device_type/listPage`,
    method: 'get',
    params
  })
}
export function getDeviceTypes () {
  return request({
    url: `/device_type/list`,
    method: 'get'
  })
}
export function getAbilityList (params) {
  return request({
    url: `/device_type_ability/listPage`,
    method: 'get',
    params
  })
}
export function updateRoom (data) {
  return request({
    url: `/room_info/update`,
    method: 'post',
    data
  })
}
